import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../components/AuthContext";
import { toast } from "react-toastify";
import "../styles/Auth.css";

export default function ForgotPasswordPage() {
const { forgotPassword } = useAuth();
const [email, setEmail] = useState("");
const [loading, setLoading] = useState(false);

const navigate = useNavigate();

const handleSubmit = async (e) => {
e.preventDefault();


if (!email.trim()) {
  toast.warning("Please enter your email");
  return;
}

if (!/\S+@\S+\.\S+/.test(email)) {
  toast.warning("Enter valid email address");
  return;
}

setLoading(true);

try {
  const res = await forgotPassword(email);

  if (res.success) {
    toast.success("OTP sent to your email");
    navigate("/reset-password");
  } else {
    toast.error(res.message || "Failed to send OTP");
  }
} catch (err) {
  console.error(err);
  toast.error("Server error. Try again.");
} finally {
  setLoading(false);
}


};

return ( <div className="auth-page"> <div className="auth-card"> <h2>Forgot Password</h2> <p>Enter your registered email to receive a reset OTP.</p>


    <form onSubmit={handleSubmit}>
      <input
        type="email"
        placeholder="Email Address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />

      <button type="submit" disabled={loading}>
        {loading ? "Sending..." : "Send OTP"}
      </button>
    </form>
  </div>
</div>


);
}
